import androidx.compose.runtime.Composable
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text

@Composable
fun ErrorString(text: String) {
    if (text != "") P(attrs = { classes("text-red-600") }) { Text(text) }
    else {}
}